module.exports = __webpack_public_path__ + "img/pay_under_contract.31df6a69.jpg";